/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.index-of.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XImg from './XImg';
import doctorDefault from '@/resources/images/doctorDefault.png';
export default {
  name: 'DoctorItem',
  components: {
    XImg: XImg
  },
  props: {
    imgSrc: String,
    imgWidth: {
      type: String,
      "default": '1.52rem'
    },
    imgHeight: {
      type: String,
      "default": '2rem'
    },
    margin: String,
    direction: {
      type: String,
      "default": 'row'
    },
    border: {
      type: Boolean,
      "default": false
    },
    imgDirection: {
      type: String,
      "default": 'left'
    },
    defaultImgSrc: {
      type: String,
      "default": doctorDefault
    },
    invalidStr: String,
    invalid: {
      type: Boolean,
      "default": false
    },
    docTechpost: String,
    docName: String,
    docSpecial: String,
    type: String,
    distance: String,
    doctorId: String
  },
  data: function data() {
    var marginStyle = this.direction === 'row' ? {
      'margin-right': this.margin
    } : {
      'margin-bottom': this.margin
    };
    var styleObject = Object.assign({}, marginStyle);
    return {
      styleObject: styleObject
    };
  },
  created: function created() {},
  methods: {
    /** 组装图片url */
    assembleImageUrl: function assembleImageUrl(imgSrc) {
      if (imgSrc && imgSrc != 'null') {
        if (imgSrc.indexOf("http") === -1 && imgSrc.indexOf('data:image') === -1) {
          // console.log(imgSrc);
          // console.log(Cons.SH_IMGROOT_PATH);
          // console.log(Cons.SZ_IMGROOT_PATH);
          if (imgSrc.indexOf('clinic/doctor') > -1) {
            return Cons.SH_IMGROOT_PATH + imgSrc;
          } else {
            return Cons.SZ_IMGROOT_PATH + imgSrc;
          }
        } else {
          return imgSrc;
        }
      } else {
        return this.defaultImgSrc;
      }
    }
  }
};